import { ArrowDropDown } from '@mui/icons-material';
import { Dropdown } from '@mui/joy';
import { first } from 'lodash';
import { useState } from 'react';

import { IAuthUser } from 'auth/types';
import { useSwitchUserVersionContext } from 'core/states';
import { IMenuItem } from 'core/types';
import { hasPermission } from 'router/utils';
import { Size, Variant } from 'theme/enums';

import { profileMenuStructure } from './structure';
import { Avatar, MenuButtonWrapper, MenuItem, MenuItemWrapper, MenuWrapper } from './style';
import { SwitchUserForm } from './SwitchUser';

const ProfileMenu = ({ user }: { user: IAuthUser | null }) => {
  const [isSwitchUserOpen, setIsSwitchUserOpen] = useState(false);

  const { onUserVersionChange } = useSwitchUserVersionContext();

  const name = `${user?.firstName} ${user?.lastName}`;

  return (
    <>
      <Dropdown>
        <MenuButtonWrapper
          size={Size.LG}
          startDecorator={
            <Avatar variant={Variant.SOLID}>
              {first(user?.firstName)}
              {first(user?.lastName)}
            </Avatar>
          }
          endDecorator={<ArrowDropDown />}
        >
          {name}
        </MenuButtonWrapper>

        <MenuWrapper size={Size.MD} placement="bottom-end">
          {profileMenuStructure(user, onUserVersionChange, () => setIsSwitchUserOpen(true)).map(
            (item: IMenuItem) =>
              hasPermission(item?.permissions, user?.resources) &&
              !item?.hide && (
                <MenuItemWrapper key={item.name}>
                  <MenuItem to={item?.url || '#'} onClick={item?.onClick}>
                    {item.name}
                  </MenuItem>
                </MenuItemWrapper>
              )
          )}
        </MenuWrapper>
      </Dropdown>

      <SwitchUserForm isOpen={isSwitchUserOpen} onClose={() => setIsSwitchUserOpen(false)} />
    </>
  );
};

export default ProfileMenu;
